export const getNameInitials = (name: string) => {
  if (!name || name.trim().length === 0) {
    return '';
  }
  const initials = name
    .split(' ')
    .map((n) => n[0]?.toUpperCase() || '')
    .filter(initial => initial !== '')
    .join('');

  return initials || name.slice(0,1).toUpperCase();
};
